<template>
  <div class="page content-page user-page">

    <div class="columns">
      <div class="column" >
          
          <h1><i class="icon icon-user"></i>Ihr Profil</h1>
          <p>Hallo {{user.firstname}} {{user.lastname}},<br>
            wir freuen uns, dass Sie sich für unsere Klinker App interessieren.</p>
          <p><strong>Ihre bei uns gespeicherten, persönlichen Daten:</strong><br>
            <span v-if="user.company">Firma: {{user.company}}<br></span>
            Ihr Name: {{user.firstname}} {{user.lastname}}<br>
            E-Mail: {{user.username}}
          </p>
          <p>Falls Ihnen unsere Klinker App gefällt, falls Sie Verbesserungsvorschläge oder Wünsche dazu haben – wir würden uns über eine Nachricht von Ihnen freuen. Sie können uns wie folgt kontaktieren:<br><br>
            <a class="button" href="tel:+492116016020">0211 - 601 602 0</a>
            <a class="button" href="mailto:info@koehler-klinker.de">E-Mail schreiben</a></p>
          
          <ul v-if="orders.items" class="orderslist">
              <li v-for="order in orderitems" :key="order.id">
                  <router-link class="order-detail-link" :to="{ name: 'OrderPage', params: { i: order.id } }">
                      <figure>
                          <div class="con"  :data-count=" getGridWidth( order.orderdata.length ) ">
                              <div v-for="(product, i) in order.orderdata" :key="i" class="prow">
                              <img v-if="product.bild != '' && ImageExist( '/upload/product-images/' + product.bild ) " :src=" '/upload/product-images/' + product.bild ">
                              <p>{{product.bez1}}</p>
                              </div>
                          </div>
                          <caption><span>Bestellung</span><span> von {{ getDateFormatted(order.orderdate)  }} </span><span>für {{ getDateFormatted(order.deliverydate) }}</span></caption>
                      </figure>
                  </router-link> 
              </li>
          </ul>
          <p><button class="button" v-if="limit && orders.items && orders.items.length > limit" v-on:click="remLimit()">Alle anzeigen</button></p>
          
        </div>
      </div>
    </div>

  </div>
</template>
<script>
export default {
    name: 'UserPage',
    data: function(){
      return {
          limit: 4
         }
    },
    methods: {
      remLimit(){
        this.limit = null
      },
      getDateFormatted(da){
        var options = { weekday: 'long', year: 'numeric', month: 'numeric', day: 'numeric' }
        var d = new Date(da)
        return d.toLocaleDateString('de-DE', options);
      },
      ImageExist(url) {
           var img = new Image();
           img.src = url;
           return true //img.width > 0;
        },
      getGridWidth( le ){
        var g = 100
        if( le > 1 ) g = 50
        if( le > 4 ) g = 33
        if( le > 9 ) g = 25
        if( le > 16 ) g = 20
        if( le > 25 ) g = 16
        if( le > 36 ) g = 14
        if( le > 49 ) g = 12
        if( le > 64 ) g = 11
        if( le > 81 ) g = 10
        if( le > 100 ) g = 9

        return g;
      },
      
    },
    created: function(){
        //this.$store.state.authentication.user.basket = [];
        //this.$store.dispatch('orders/getAll');
    },
    mounted: function(){},
    computed: {
        user () {
            //console.log(this.$store.state.authentication.user)
            return this.$store.state.authentication.user
        },
        orders (){
          return {} //this.$store.state.orders.all
        },
        orderitems() {
            //console.log( this.$store.state.orders.all );
            
            if( this.$store.state.orders.all.items ) 
              return this.limit ? this.$store.state.orders.all.items.slice(0,this.limit) : this.$store.state.orders.all.items
        }
    }
}  
</script>
<style>
  .orderslist { display: flex; flex-wrap: wrap; padding: 0; margin: 0; list-style: none; margin: 0 -0.43333em; }
  .orderslist li { flex: 1 1 25%; width: 25%; max-width: 25%; margin: 0; padding: 0.433333em; }
  .order-detail-link { display: block; color: #00853e; font-size: 1rem; text-decoration: none; position: relative; padding: 100% 0 0 0; }
  .order-detail-link figure { margin: 0; padding: 0; background: #f0f1f2; position: absolute; overflow: hidden; top: 0; right: 0; bottom: 0; left: 0; }
  .order-detail-link figure caption { display: block; position: absolute; left: 0; right: 0; bottom: 0; padding: 0.4333333em 0.73333em; color:#00853e; background:rgba(255,255,255,0.8); text-align: left; }
  .order-detail-link figure caption span { display: block; } 
  .order-detail-link figure div.con { display: flex; flex-wrap: wrap; transform: scale(1.01); transition: transform 0.9s ease; }
  .order-detail-link:hover figure div.con { transform: scale(1.06); }
  .order-detail-link figure div.con img { display: block; flex: 1 1 14%; max-width: 14%; }
  .order-detail-link figure div.con .prow { display: flex; align-items: center; border-bottom: 1px solid #ddd; }
  .order-detail-link figure div.con .prow p { margin: 0; padding: 0.2em 0.63333em 0; font-size: 0.7rem;}
/*
  .order-detail-link figure div.con[data-count="50"] img { max-width: 50%; }
  .order-detail-link figure div.con[data-count="33"] img { max-width: 33.333%; }
  .order-detail-link figure div.con[data-count="25"] img { max-width: 25%; }
  .order-detail-link figure div.con[data-count="20"] img { max-width: 20%; }
  .order-detail-link figure div.con[data-count="16"] img { max-width: 16.666%; }
  .order-detail-link figure div.con[data-count="14"] img { max-width: 14.284%; }
  .order-detail-link figure div.con[data-count="12"] img { max-width: 12.5%; }
  .order-detail-link figure div.con[data-count="11"] img { max-width: 11.11%; }
  .order-detail-link figure div.con[data-count="9"] img { max-width: 9.0909%; }
*/
  
  @media screen and (min-width: 30em ) {
     .orderslist li { flex: 1 1 50%; width: 50%; max-width: 50%; margin: 0; padding: 0.433333em; }
  }
  @media screen and (min-width: 40em ) {
     .orderslist li { flex: 1 1 33.333%; width: 33.333%; max-width: 33.333%; margin: 0; padding: 0.433333em; }
  }
  @media screen and (min-width: 64em ) {
     .orderslist li { flex: 1 1 25%; width: 25%; max-width: 25%; margin: 0; padding: 0.433333em; }
  }


  
</style>